import { IFilteredHistoryEntry, IHistoryEntry, ITransactionEntry } from "@monorepo/types";

export const getHistoryEntryPaidDate = (entry: IHistoryEntry | IFilteredHistoryEntry | ITransactionEntry) => {
  if (entry.paid_at) {
    return entry.paid_at;
  }
  return entry.first_financial_at;
};
